import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isFetching: boolean;
  fields: string[];
  translatedMessage: string;
}

const initialState: StateInterface = {
  isFetching: false,
  fields: [],
  translatedMessage: ""
};

export const paymentCreateDialogReducer =
    (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.GLOBAL_PAYMENT_CREATE_REQUEST:
      return {
        ...state,
        isFetching: true
      };

    case Constants.GLOBAL_PAYMENT_CREATE_SUCCESS:
      return {
        ...state,
        isFetching: false
      };

    case Constants.GLOBAL_PAYMENT_CREATE_AND_LINK_FAILURE:
      const fields: string[] = [];

      if (action.payload?.err.fields.charge && action.payload?.err.fields.charge.includes("firstDate")) {
        fields.push("firstDateForCharge");
      }

      if (action.payload?.err.fields.charge && action.payload?.err.fields.charge.includes("invoiceDate")) {
        fields.push("invoiceDateForCharge");
      }

      if (action.payload?.err.fields.charge && action.payload?.err.fields.charge.includes("invoiceNumber")) {
        fields.push("invoiceNumberForCharge");
      }
      
      if (action.payload?.err.fields.charge && action.payload?.err.fields.charge.includes("amount")) {
        fields.push("amountForCharge");
      }

      if (action.payload?.err.fields.charge && action.payload?.err.fields.charge.includes("currency")) {
        fields.push("currencyIdForCharge");
      }

      if (action.payload?.err.fields.charge && action.payload?.err.fields.charge.includes("vat")) {
        fields.push("vatForCharge");
      }

      if (action.payload?.err.fields.charge && action.payload?.err.fields.charge.includes("type")) {
        fields.push("typeIdForCharge");
      }

      if (action.payload?.err.fields.charge && action.payload?.err.fields.charge.includes("contactId")) {
        fields.push("selectedPersonForCharge");
      }

      if (action.payload?.err.fields.charge && action.payload?.err.fields.charge.includes("contactId")) {
        fields.push("selectedCompanyForCharge");
      }

      if (action.payload?.err.message === "Charge requires at least one relation"
      || (action.payload?.err.fields.charge && 
        action.payload?.err.fields.charge.indexOf("propertyId") > -1 &&
        action.payload?.err.fields.charge.indexOf("unitId") > -1 &&
        action.payload?.err.fields.charge.indexOf("contractId") > -1)) {
          fields.push("objectId");
      }
      
      if (action.payload?.err.fields.charge && action.payload?.err.fields.charge.includes("objectId")) {
        fields.push("objectId")
      }

      if (action.payload?.err.fields.charge && action.payload?.err.fields.charge.includes("description")) {
        fields.push("descriptionForCharge");
      }

      if (action.payload?.err.fields.payment && action.payload?.err.fields.payment.includes("amount")) {
        fields.push("amountForPayment");
      }

      if (action.payload?.err.fields.payment && action.payload?.err.fields.payment.includes("currency")) {
        fields.push("currencyIdForPayment");
      }

      if (action.payload?.err.fields.payment && action.payload?.err.fields.payment.includes("dateOfThePayment")) {
        fields.push("dateOfThePayment");
      }

      if (action.payload?.err.fields.payment && action.payload?.err.fields.payment.includes("firstDateOfStatementPeriod")) {
        fields.push("firstDateOfStatementPeriodForPayment");
      }

      if (action.payload?.err.fields.payment && action.payload?.err.fields.payment.includes("agencyBankAccount")) {
        fields.push("agencyBankAccountIdForPayment");
      }

      if (action.payload?.err.fields.payment && action.payload?.err.fields.payment.includes("contactId")) {
        fields.push("selectedPersonForPayment");
      }

      if (action.payload?.err.fields.payment && action.payload?.err.fields.payment.includes("contactId")) {
        fields.push("selectedCompanyForPayment");
      }

      if (action.payload?.err.fields.payment && action.payload?.err.fields.payment.includes("description")) {
        fields.push("descriptionForPayment");
      }

      return {
        ...state,
        isFetching: false,
        fields: fields,
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_PAYMENT_CREATE_FAILURE:
      const paymentFields: string[] = [];

      if (action.payload?.err.fields.includes("amount")) {
        paymentFields.push("amountForPayment");
      }

      if (action.payload?.err.fields.includes("currency")) {
        paymentFields.push("currencyIdForPayment");
      }

      if (action.payload?.err.fields.includes("date")) {
        paymentFields.push("firstDateOfStatementPeriodForPayment");
      }

      if (action.payload?.err.fields.includes("agencyBankAccount")) {
        paymentFields.push("agencyBankAccountIdForPayment");
      }

      if (action.payload?.err.fields.includes("contactId")) {
        paymentFields.push("selectedPersonForPayment");
      }

      if (action.payload?.err.fields.includes("companyId")) {
        paymentFields.push("selectedCompanyForPayment");
      }

      if (action.payload?.err.fields.includes("description")) {
        paymentFields.push("descriptionForPayment");
      }

      if (action.payload?.err.fields.includes("mainBankAccountId")) {
        paymentFields.push("counterpartyIbanForPayment");
      }

      return {
        ...state,
        isFetching: false,
        fields: paymentFields,
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_CHARGE_CREATE_FAILURE:
      const chargeFields: string[] = [];

      if (action.payload?.err.fields.includes("invoiceDate")) {
        chargeFields.push("invoiceDateForCharge");
      }

      if (action.payload?.err.fields.includes("invoiceNumber")) {
        chargeFields.push("invoiceNumberForCharge");
      }

      if (action.payload?.err.fields.includes("amount")) {
        chargeFields.push("amountForCharge");
      }

      if (action.payload?.err.fields.includes("currency")) {
        chargeFields.push("currencyIdForCharge");
      }

      if (action.payload?.err.fields.includes("vat")) {
        chargeFields.push("vatForCharge");
      }

      if (action.payload?.err.fields.includes("type")) {
        chargeFields.push("typeIdForCharge");
      }

      if (action.payload?.err.fields.includes("contactId")) {
        chargeFields.push("selectedPersonForCharge");
      }

      if (action.payload?.err.fields.includes("companyId")) {
        chargeFields.push("selectedCompanyForCharge");
      }

      if(action.payload?.err.fields.includes("objectId")) {
        chargeFields.push("objectId")
      }

      if (action.payload?.err.message === "Charge requires at least one relation"
          || (action.payload?.err.fields.indexOf("propertyId") > -1 &&
              action.payload?.err.fields.indexOf("unitId") > -1 &&
                action.payload?.err.fields.indexOf("contractId") > -1)) {
        chargeFields.push("objectId");
      }

      if (action.payload?.err.fields.includes("firstDate")) {
        chargeFields.push("firstDateForCharge");
      }

      if (action.payload?.err.fields.includes("description")) {
        chargeFields.push("descriptionForCharge");
      }
      
      return {
        ...state,
        isFetching: false,
        fields: chargeFields,
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_CHARGE_TYPE_CREATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_BANK_ACCOUNT_CREATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_PAYMENT_CREATE_CLEAR:
    case Constants.GLOBAL_PAYMENT_CREATE_AND_LINK_CLEAR:
    case Constants.GLOBAL_CHARGE_CREATE_CLEAR:
    case Constants.GLOBAL_CHARGE_TYPE_CREATE_CLEAR:
    case Constants.GLOBAL_BANK_ACCOUNT_CREATE_CLEAR:
    case Constants.GLOBAL_PAYMENT_LINK_CLEAR:
    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
